
var angular = require('angular');
var _module = angular.module('listreports.book-demo', []);

function urlWithParams(url, params) {
    params = params || {};
    var parsedUrl = new URL(url);
    Object.entries(params).map(function(entry) {
        key = entry[0];
        value = entry[1];
        if(!parsedUrl.searchParams.has(key)) {
            parsedUrl.searchParams.append(key, value);
        }
    });
    return parsedUrl.toString();
}

_module.directive('bookDemo', function() {
    return {
        restrict: 'E',
        scope: {},
        bindToController: true,
        controllerAs: 'vm',
        templateUrl: 'js/components/book-demo/index.tmpl.html',
        controller: ['$http', '$stateParams', function($http, $stateParams) {
            var vm = this;
            vm.submitting = false;
            vm.formData = {
                firstName: '',
                lastName: '',
                email: '',
            }

            var campaign = $stateParams.campaign || 'website';
            var path = $stateParams.path || 'listreports-team/ib-listreports-demo';

            campaign = decodeURIComponent(campaign);
            path = decodeURIComponent(path);

            vm.submit = function() {
                vm.submitting = true;
                var params = {
                    first_name: vm.formData.firstName,
                    last_name: vm.formData.lastName,
                    email: vm.formData.email,
                    utm_campaign: campaign
                };

                var fallbackRedirectUrl = urlWithParams('https://calendly.com/' + path, params);
                var ownerCheckUrl = "https://lr-salesforce.cron.listreports.com" + "/v1/contacts/" + vm.formData.email + "/owner?lookupKey=email";
                $http.get(ownerCheckUrl)
                    .then(function(response) {
                        vm.submitting = false;
                        var responseData = response.data.data;
                        if(responseData && responseData.owner.Calendly_Link__c) {
                            window.location.href = urlWithParams(responseData.owner.Calendly_Link__c, params);
                        } else {
                            window.location.href = fallbackRedirectUrl;
                        }
                    })
                    .catch(function() {
                        vm.submitting = false;
                        window.location.href = fallbackRedirectUrl;
                    });
            }
        }]
    }
})
